import { useEffect, useRef } from "react";

export function Toast(props: {
  message: string;
  onUndo?: () => void;
  onDismiss?: () => void;
  durationMs?: number;
}) {
  const { message, onUndo, onDismiss, durationMs = 4000 } = props;

  // Detect reduced-motion preference
  const reducedMotion =
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      onDismiss?.();
    }, durationMs);
    return () => {
      if (timerRef.current !== null) clearTimeout(timerRef.current);
    };
  }, [durationMs, onDismiss]);

  return (
    <div
      role="status"
      aria-live="polite"
      className={`toast${reducedMotion ? "" : " toast--animate"}`}
      style={{
        position: "fixed",
        bottom: "24px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        background: "var(--card)",
        border: "1px solid var(--border)",
        borderRadius: "12px",
        boxShadow: "0 4px 24px rgba(15,26,48,0.14)",
        padding: "12px 18px",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        fontSize: "14px",
        fontWeight: 500,
        color: "var(--text)",
        minWidth: "220px",
        maxWidth: "420px",
        animation: reducedMotion ? "none" : "scPop 0.18s ease",
      }}
    >
      <span style={{ flex: 1 }}>{message}</span>
      {onUndo && (
        <button
          onClick={onUndo}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "var(--helio-orange)",
            font: "600 13px var(--font-head)",
            padding: "0 4px",
          }}
        >
          Undo
        </button>
      )}
    </div>
  );
}
